import { RuleBuilderField } from '../../create-report/rule-builder';

const isObject = (obj: unknown): boolean => {
  return typeof obj === 'object' && obj !== null;
};

// exclude null, undefined, and empty string comparisons
const toExclude = [null, '', undefined];

const objectsAreEqual = (obj1: object, obj2: object): boolean => {
  if (obj1 === obj2) {
    return true;
  }
  if (isObject(obj1) && isObject(obj2)) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }
    for (const key in obj1) {
      if (!objectsAreEqual(obj1[key], obj2[key])) {
        if (toExclude.includes(obj1[key]) && toExclude.includes(obj2[key])) {
          continue;
        }
        // workaround for fillInMissingLabelForDropdownInput
        // label is initially set to empty string and later updated
        if (key === 'label' && obj2[key] === '') {
          continue;
        }
        // workaround for non matching keys in runby dropdowns
        // compare the values instead
        if (key === 'key' && obj1['value'] === obj2['value']) {
          continue;
        }
        // workaround for non matching ids in rule in rule[]
        // removing a rule and adding it back results in a different id than previous
        // compare field keys instead
        if (key === 'id' && obj1['fieldKey'] === obj2['fieldKey']) {
          continue;
        }
        // workaround for newly added rules
        // when removing a rule and adding it back, the key isNew: true
        if (key === 'isNew') {
          continue;
        }

        return false;
      }
    }
    return true;
  }
};

const areFieldsEqual = (
  arr1: RuleBuilderField[],
  arr2: RuleBuilderField[],
): boolean => {
  let areEqual = true;
  if (arr1.length !== arr2.length) {
    return false;
  }
  arr1.forEach((_, index) => {
    if (!objectsAreEqual(arr1[index], arr2[index])) {
      areEqual = false;
    }
  });
  return areEqual;
};

export { objectsAreEqual, areFieldsEqual };
